import { render, staticRenderFns } from "./FormArchivo.vue?vue&type=template&id=af1e6326"
import script from "./FormArchivo.vue?vue&type=script&lang=js"
export * from "./FormArchivo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports